// Shared bits for a control whose LABEL is data the operator wants to copy
// ("Show extracted content - 6,486 chars, 7 of 11 facts", "3 attachments"),
// not just a verb. Chrome and Safari apply `user-select: none` to buttons in
// their UA stylesheet, so a <button> label is unselectable by default - the
// same trap the Drive tree's filename link hit.
//
// Kept as a button (not a div with a click handler) so it stays focusable,
// keyboard-activatable and announced as a control for free.

export const SELECTABLE_LABEL_STYLE: React.CSSProperties = {
  userSelect: "text",
  WebkitUserSelect: "text",
};

// A drag to select the label ends with mouseup inside the control, which the
// browser also reports as a click - so without this guard, selecting the text
// toggles the panel underneath it. Keyboard activation reports `detail === 0`
// and is never suppressed; a plain click collapses any prior selection before
// the click event, so this only fires for a drag that ended on the control.
export const isTextSelectionClick = (
  event: React.MouseEvent<HTMLElement>,
): boolean => {
  if (event.detail === 0) return false;
  const selection = window.getSelection();
  return (
    selection !== null &&
    !selection.isCollapsed &&
    selection.toString().trim() !== ""
  );
};
